/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import { Role, RoleFromJSON, RoleFromJSONTyped, RoleToJSON } from "./Role";
import {
	StudentYearEnum,
	StudentYearEnumFromJSON,
	StudentYearEnumFromJSONTyped,
	StudentYearEnumToJSON,
} from "./StudentYearEnum";

/**
 *
 * @export
 * @interface AcademicUserProfileDTO
 */
export interface AcademicUserProfileDTO {
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserProfileDTO
	 */
	id?: string;
	/**
	 *
	 * @type {Role}
	 * @memberof AcademicUserProfileDTO
	 */
	role?: Role;
	/**
	 *
	 * @type {StudentYearEnum}
	 * @memberof AcademicUserProfileDTO
	 */
	year?: StudentYearEnum;
	/**
	 *
	 * @type {string}
	 * @memberof AcademicUserProfileDTO
	 */
	facultyAcronym?: string | null;
	/**
	 *
	 * @type {boolean}
	 * @memberof AcademicUserProfileDTO
	 */
	isPrimaryProfile?: boolean;
}

export function AcademicUserProfileDTOFromJSON(
	json: any
): AcademicUserProfileDTO {
	return AcademicUserProfileDTOFromJSONTyped(json, false);
}

export function AcademicUserProfileDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): AcademicUserProfileDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		role: !exists(json, "role") ? undefined : RoleFromJSON(json["role"]),
		year: !exists(json, "year")
			? undefined
			: StudentYearEnumFromJSON(json["year"]),
		facultyAcronym: !exists(json, "facultyAcronym")
			? undefined
			: json["facultyAcronym"],
		isPrimaryProfile: !exists(json, "isPrimaryProfile")
			? undefined
			: json["isPrimaryProfile"],
	};
}

export function AcademicUserProfileDTOToJSON(
	value?: AcademicUserProfileDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		role: RoleToJSON(value.role),
		year: StudentYearEnumToJSON(value.year),
		facultyAcronym: value.facultyAcronym,
		isPrimaryProfile: value.isPrimaryProfile,
	};
}
